(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zg-feature-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-zg-feature-carousel]').forEach((root) => {
      if (root.dataset.zgCarouselBound === 'true') return;
      root.dataset.zgCarouselBound = 'true';

      const viewport = root.querySelector('[data-zg-feature-viewport]');
      const slides = Array.from(root.querySelectorAll('[data-zg-feature-slide]'));
      const prev = root.querySelector('[data-zg-feature-prev]');
      const next = root.querySelector('[data-zg-feature-next]');
      const current = root.querySelector('[data-zg-feature-current]');

      if (!viewport || slides.length < 2) return;

      let active = 0;

      const clampIndex = (index) => {
        if (index < 0) return slides.length - 1;
        if (index >= slides.length) return 0;
        return index;
      };

      const goTo = (index) => {
        active = clampIndex(index);
        viewport.scrollTo({
          left: active * viewport.clientWidth,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        if (current) current.textContent = String(active + 1);
      };

      prev?.addEventListener('click', () => goTo(active - 1));
      next?.addEventListener('click', () => goTo(active + 1));

      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(active - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(active + 1);
        }
      });

      let frame = null;
      viewport.addEventListener('scroll', () => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const width = viewport.clientWidth || 1;
          active = clampIndex(Math.round(viewport.scrollLeft / width));
          if (current) current.textContent = String(active + 1);
        });
      }, { passive: true });

      window.addEventListener('resize', () => {
        viewport.scrollLeft = active * viewport.clientWidth;
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zg-size-confirmation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-zg-size-dialog]');
    if (!dialog || dialog.dataset.zgBound === 'true') return;
    dialog.dataset.zgBound = 'true';

    const ranges = {
      S: { fit: 'XS/S', men: '4–7', women: '5–8', eu: '36–40', next: 'M' },
      M: { fit: 'M/L', men: '7.5–10.5', women: '8.5–11.5', eu: '40.5–45', next: 'L' },
      L: { fit: 'L/XL', men: '11–14', women: '12–15', eu: '45.5–49' }
    };

    const announcement = document.querySelector('[data-zg-size-announcement]');
    let pendingInput = null;
    let pendingContext = null;
    let checkoutContext = null;

    const sizeValue = (input) => {
      const candidates = [input?.value, input?.dataset?.value, input?.labels?.[0]?.textContent];
      const value = candidates
        .map((candidate) => candidate?.trim().toUpperCase())
        .find((candidate) => ranges[candidate]);
      return value || null;
    };

    const isSizeInput = (input) => {
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !sizeValue(input)) return false;
      if (input.matches('[data-zg-conversion-home] .zg-size-options input')) return true;
      const legend = input.closest('fieldset')?.querySelector(':scope > legend');
      return legend?.textContent.trim().toLowerCase() === 'size';
    };

    const inputFromTarget = (target) => {
      if (!(target instanceof Element)) return null;
      if (target instanceof HTMLInputElement) return target;
      const label = target.closest('label');
      if (!label) return null;
      const nested = label.querySelector('input[type="radio"]');
      if (nested) return nested;
      const inputId = label.getAttribute('for');
      return inputId ? document.getElementById(inputId) : null;
    };

    const contextFor = (input) => {
      const homeForm = input.closest('#zg-home-product-form');
      if (homeForm) return homeForm;
      return input.closest('product-information, .product-information, .shopify-section') || document.body;
    };

    const statusFor = (input) => {
      const fieldset = input.closest('fieldset');
      if (!fieldset) return null;
      let status = fieldset.parentElement?.querySelector(':scope > [data-zg-size-inline-status]');
      if (!status) {
        status = document.createElement('p');
        status.className = 'zg-size-confirmation__inline-status';
        status.dataset.zgSizeInlineStatus = '';
        status.setAttribute('aria-live', 'polite');
        fieldset.insertAdjacentElement('afterend', status);
      }
      return status;
    };

    const updateStatus = (input, message, state) => {
      const status = statusFor(input);
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('is-confirmed', state === 'confirmed');
      status.classList.toggle('is-required', state === 'required');
    };

    const fillDialog = (size) => {
      const range = ranges[size];
      dialog.querySelector('[data-zg-confirm-size]').textContent = size;
      dialog.querySelector('[data-zg-confirm-button-size]').textContent = size;
      dialog.querySelector('[data-zg-confirm-fit]').textContent = range.fit;
      dialog.querySelector('[data-zg-confirm-men]').textContent = range.men;
      dialog.querySelector('[data-zg-confirm-women]').textContent = range.women;
      dialog.querySelector('[data-zg-confirm-eu]').textContent = range.eu;
      const compressionNote = dialog.querySelector('[data-zg-compression-note]');
      compressionNote.hidden = !range.next;
      compressionNote.textContent = range.next
        ? `Close to the upper end of this range? Because these are compression-fit socks, consider choosing ${range.next} if you prefer less compression.`
        : '';
    };

    const openConfirmation = (input, requiredMessage = false) => {
      if (!isSizeInput(input)) return;
      if (dialog.open && pendingInput === input) return;

      const size = sizeValue(input);
      pendingInput = input;
      pendingContext = contextFor(input);
      checkoutContext = null;
      pendingContext.dataset.zgConfirmedSize = '';
      fillDialog(size);

      if (requiredMessage) {
        updateStatus(input, dialog.dataset.requiredMessage, 'required');
      } else {
        updateStatus(input, '', '');
      }

      if (!dialog.open) dialog.showModal();
    };

    const productFormFor = (input) => {
      const homeForm = input.closest('#zg-home-product-form');
      if (homeForm) return homeForm;

      const context = contextFor(input);
      return context.querySelector('form[data-type="add-to-cart-form"]');
    };

    const selectedSizeInputForForm = (form) => {
      if (form.id === 'zg-home-product-form') {
        return form.querySelector('.zg-size-options input[type="radio"]:checked');
      }

      const root = form.closest('product-information, .product-information, .shopify-section') || document;
      const picker = root.querySelector('variant-picker[data-template-product-match="true"]') || root.querySelector('variant-picker');
      if (!picker) return null;
      return Array.from(picker.querySelectorAll('input[type="radio"]:checked')).find(isSizeInput) || null;
    };

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (isSizeInput(input)) openConfirmation(input);
    }, true);

    document.addEventListener('click', (event) => {
      const input = inputFromTarget(event.target);
      if (!isSizeInput(input)) return;
      window.setTimeout(() => openConfirmation(input), 0);
    }, true);

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.id !== 'zg-home-product-form' && form.dataset.type !== 'add-to-cart-form') return;

      const input = selectedSizeInputForForm(form);
      if (!input) return;

      const size = sizeValue(input);
      const context = contextFor(input);
      if (context.dataset.zgConfirmedSize === size) {
        checkoutContext = context;
        if (form.id === 'zg-home-product-form') {
          event.preventDefault();
          event.stopImmediatePropagation();
          const cartAddUrl = new URL(form.action, window.location.origin);
          cartAddUrl.pathname = `${cartAddUrl.pathname.replace(/\/$/, '')}.js`;
          fetch(cartAddUrl.toString(), {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          })
            .then((response) => {
              if (!response.ok) throw new Error('Product could not be added.');
              return response.json();
            })
            .then(() => window.location.assign('/cart'))
            .catch(() => updateStatus(input, 'We could not add this size. Please try again.', 'required'));
          return;
        }

        let returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          form.appendChild(returnTo);
        }
        returnTo.value = '/cart';
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      openConfirmation(input, true);
    }, true);

    document.addEventListener('cart:update', (event) => {
      const data = event.detail?.data;
      if (!checkoutContext || data?.source !== 'product-form-component' || data?.didError) return;
      if (!checkoutContext.contains(event.target)) return;
      checkoutContext = null;
      window.location.assign('/cart');
    });

    dialog.addEventListener('close', () => {
      if (!pendingInput || !pendingContext) return;

      const confirmedInput = pendingInput;
      const confirmedContext = pendingContext;
      const size = sizeValue(confirmedInput);
      const isConfirmed = dialog.returnValue === 'confirm';
      const productForm = isConfirmed ? productFormFor(confirmedInput) : null;

      if (isConfirmed) {
        confirmedContext.dataset.zgConfirmedSize = size;
        const message = `${dialog.dataset.confirmedMessage}: ${size}`;
        updateStatus(confirmedInput, message, 'confirmed');
        if (announcement) announcement.textContent = message;
      } else {
        checkoutContext = null;
        confirmedContext.dataset.zgConfirmedSize = '';
        updateStatus(confirmedInput, dialog.dataset.requiredMessage, 'required');
      }

      confirmedInput.focus({ preventScroll: true });
      pendingInput = null;
      pendingContext = null;

      if (productForm) {
        window.setTimeout(() => {
          if (productForm.isConnected) productForm.requestSubmit();
        }, 0);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
